/* ============================================================
   Bruxora — JS du thème
   - Panier latéral branché sur l'Ajax API Shopify (/cart/add.js, /cart.js, /cart/change.js)
   - Filtres par type de produit + recherche instantanée sur la page d'accueil
   - Page produit : galerie, quantité, ajout sans rechargement
   - Menu mobile, toast
   ============================================================ */
(function () {
  "use strict";
  const cfg = window.bruxora || { routes: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Prix : format Shopify (money_with_currency_format) ---------- */
  function money(cents) {
    const amount = (cents / 100).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    const fmt = cfg.moneyFormat || "{{amount_with_comma_separator}} €";
    return fmt.replace(/\{\{\s*amount\w*\s*\}\}/, amount).replace(/<[^>]+>/g, "");
  }
  const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const catClass = (type) => { const t = (type || "").toLowerCase(); return t.includes("beaut") ? "beaute" : t.includes("tech") ? "tech" : "autre"; };

  /* ---------- Toast ---------- */
  const toastEl = $("#toast"); let toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.hidden = false;
    requestAnimationFrame(() => toastEl.classList.add("is-visible"));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toastEl.classList.remove("is-visible"); setTimeout(() => { toastEl.hidden = true; }, 240); }, 2200);
  }

  /* ---------- Panier (Ajax API) ---------- */
  const cartEl = $("#cart"), overlay = $("#cart-overlay"), items = $("#cart-items"), emptyEl = $("#cart-empty"),
        footEl = $("#cart-foot"), countEl = $("#cart-count"), subtotalEl = $("#cart-subtotal"), openBtn = $("#cart-open");

  async function fetchCart() { return (await fetch(cfg.routes.cartFetch, { headers: { Accept: "application/json" } })).json(); }

  async function addToCart(id, quantity = 1) {
    const res = await fetch(cfg.routes.cartAdd + ".js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity }] })
    });
    if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.description || "Ajout impossible"); }
    return renderCart(await fetchCart());
  }
  async function changeLine(key, quantity) {
    const res = await fetch(cfg.routes.cartChange + ".js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity })
    });
    return renderCart(await res.json());
  }

  function renderCart(cart) {
    if (!cartEl) return cart;
    items.innerHTML = cart.items.map((it) => `
      <div class="cart-item cart-item--${catClass(it.product_type)}" data-key="${esc(it.key)}">
        <a class="cart-item__media" href="${esc(it.url)}">${it.image ? `<img src="${esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2"))}" alt="">` : ""}</a>
        <div>
          <h4>${esc(it.product_title)}</h4>
          <p class="cart-item__meta">${it.variant_title ? esc(it.variant_title) + " · " : ""}${money(it.price)}</p>
          <div class="cart-item__qty" aria-label="Quantité">
            <button type="button" data-qty="${it.quantity - 1}" aria-label="Retirer un exemplaire">−</button>
            <span>${it.quantity}</span>
            <button type="button" data-qty="${it.quantity + 1}" aria-label="Ajouter un exemplaire">+</button>
          </div>
        </div>
        <div class="cart-item__right">
          <strong class="price">${money(it.final_line_price)}</strong>
          <button type="button" class="cart-item__remove" data-qty="0">Supprimer</button>
        </div>
      </div>`).join("");
    emptyEl.hidden = cart.item_count > 0;
    footEl.hidden = cart.item_count === 0;
    subtotalEl.textContent = money(cart.total_price);
    countEl.textContent = String(cart.item_count);
    countEl.hidden = cart.item_count === 0;
    countEl.classList.remove("bump"); void countEl.offsetWidth; countEl.classList.add("bump");
    return cart;
  }

  function openCart() {
    if (!cartEl) return;
    cartEl.classList.add("is-open"); overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add("is-open"));
    cartEl.setAttribute("aria-hidden", "false"); openBtn.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden"; $("#cart-close").focus();
  }
  function closeCart() {
    cartEl.classList.remove("is-open"); overlay.classList.remove("is-open");
    cartEl.setAttribute("aria-hidden", "true"); openBtn.setAttribute("aria-expanded", "false");
    document.body.style.overflow = ""; setTimeout(() => { overlay.hidden = true; }, 260); openBtn.focus();
  }

  if (cartEl) {
    openBtn.addEventListener("click", async () => { openCart(); try { renderCart(await fetchCart()); } catch (_) {} });
    $("#cart-close").addEventListener("click", closeCart);
    overlay.addEventListener("click", closeCart);
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && cartEl.classList.contains("is-open")) closeCart(); });
    items.addEventListener("click", (e) => {
      const b = e.target.closest("[data-qty]"); if (!b) return;
      changeLine(b.closest(".cart-item").dataset.key, Number(b.dataset.qty)).catch(() => toast("Mise à jour impossible"));
    });
    fetchCart().then(renderCart).catch(() => {});
  }

  // Boutons "Ajouter au panier" (cartes, hero)
  document.addEventListener("click", async (e) => {
    const b = e.target.closest("button[data-add]"); if (!b) return;
    b.disabled = true;
    try { await addToCart(b.dataset.add, 1); toast("Ajouté au panier"); openCart(); }
    catch (err) { toast(err.message); }
    finally { b.disabled = false; }
  });

  // Formulaire page produit
  const pf = $("#product-form");
  if (pf) {
    pf.addEventListener("submit", async (e) => {
      e.preventDefault();
      const btn = $("#product-add"); btn.disabled = true;
      try { await addToCart(pf.querySelector("[name=id]").value, Number(pf.querySelector("[name=quantity]").value) || 1); toast("Ajouté au panier"); openCart(); }
      catch (err) { toast(err.message); }
      finally { btn.disabled = false; }
    });
    $$("[data-step]", pf).forEach((b) => b.addEventListener("click", () => {
      const q = pf.querySelector("[name=quantity]"); q.value = Math.max(1, (Number(q.value) || 1) + Number(b.dataset.step));
    }));
    $$(".product__thumb").forEach((t) => t.addEventListener("click", () => {
      $$(".product__thumb").forEach((x) => x.classList.remove("is-active")); t.classList.add("is-active");
      $("#product-main-media img").src = t.dataset.thumb;
    }));
  }

  /* ---------- Accueil : filtres + recherche instantanée ---------- */
  const grid = $("#product-grid");
  if (grid) {
    const state = { filter: "all", query: "" };
    const emptyState = $("#empty-state"), count = $("#results-count");
    function apply() {
      const q = state.query.trim().toLowerCase(); let n = 0;
      $$(".card", grid).forEach((c) => {
        const ok = (state.filter === "all" || c.dataset.category === state.filter) && (!q || (c.dataset.search || "").toLowerCase().includes(q));
        c.hidden = !ok; if (ok) n++;
      });
      emptyState.hidden = n > 0;
      count.textContent = n ? `${n} produit${n > 1 ? "s" : ""}` : "";
    }
    function setFilter(f) {
      state.filter = f;
      $$(".filter").forEach((b) => { const a = b.dataset.filter === f; b.classList.toggle("is-active", a); b.setAttribute("aria-selected", String(a)); });
      apply();
    }
    $$(".filter").forEach((b) => b.addEventListener("click", () => setFilter(b.dataset.filter)));
    $$("input[type=search]").forEach((i) => i.addEventListener("input", () => {
      state.query = i.value; $$("input[type=search]").forEach((o) => { if (o !== i) o.value = i.value; }); apply();
      const top = $("#catalogue").getBoundingClientRect().top;
      if (i.value && top > window.innerHeight * 0.6) $("#catalogue").scrollIntoView({ behavior: "smooth" });
    }));
    $("#reset-search").addEventListener("click", () => { state.query = ""; $$("input[type=search]").forEach((i) => (i.value = "")); setFilter("all"); });
    apply();
  }

  /* ---------- Menu mobile ---------- */
  const navToggle = $("#nav-toggle"), mobileNav = $("#mobile-nav");
  if (navToggle) navToggle.addEventListener("click", () => {
    const open = navToggle.getAttribute("aria-expanded") !== "true";
    navToggle.setAttribute("aria-expanded", String(open)); mobileNav.hidden = !open; mobileNav.classList.toggle("is-open", open);
  });
})();
